import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Spesen } from '../../models/spesen-model';

@Component({
  selector: 'app-spesen-dialog',
  templateUrl: './spesen-dialog.component.html',
  styleUrls: ['./spesen-dialog.component.scss'],
})
export class SpesenDialogComponent implements OnInit {
  faSave = faSave;
  spesenForm = new UntypedFormGroup({
    spesen: new UntypedFormControl(''),
    menge: new UntypedFormControl(''),
    betrag: new UntypedFormControl(''),
  });
  public spesenModel!: Spesen[];

  constructor(
    public dialogRef: MatDialogRef<SpesenDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public componentData: any
  ) {}

  ngOnInit(): void {
    if(!this.componentData.position?.top) {
      this.dialogRef.updatePosition({top: "3.75rem"})
    }
    this.setDialogData();
    this.spesenModel = this.componentData.data.spesen;
    this.spesenForm.controls['spesen'].valueChanges.subscribe({
      next: (res) => {
        const spesen = this.spesenModel.find((el) => el.description === res);
        this.spesenForm.controls['menge'].setValue(spesen?.amountOne);
        this.spesenForm.controls['betrag'].setValue(spesen?.rate);
      },
    });
  }

  setDialogData() {
    this.spesenForm.controls['spesen'].setValue(
      this.componentData.data.selectedSpesen.description
    );
    this.spesenForm.controls['menge'].setValue(
      +this.componentData.data.selectedSpesen.menge
    );
    this.spesenForm.controls['betrag'].setValue(
      +this.componentData.data.selectedSpesen.betrag
    );
  }

  next() {
    let spesenValue;
    const pickedCost = this.spesenModel.find(
      (el) => el.description === this.spesenForm.controls['spesen'].value
    );
    spesenValue = {
      expenseID: pickedCost?.expenseID,
      description: pickedCost?.description,
      amountOne: pickedCost?.amountOne,
      rate: pickedCost?.rate,
      menge: this.spesenForm.controls['menge'].value,
      betrag: this.spesenForm.controls['betrag'].value,
    };
    this.dialogRef.close({ value: spesenValue });
  }
}
